import useProjectInfoContext from '../../../../../../../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import { useOrganisationData } from '../../../../../../../../../../Hooks/useOrganisation';
import { useUserInfoData } from '../../../../../../../../../../Hooks/useUserInfo';

export default function useEnableSummary() {
  const { project } = useProjectInfoContext();
  const userInfo = useUserInfoData();
  const org = useOrganisationData();

  if (!project?.summaryConfig?.instruction) {
    return false;
  }

  if (!org.features.cogneedAi?.sessionSummary?.enabled) {
    return false;
  }

  if (org.features.cogneedAi?.sessionSummary?.staffOnly && !userInfo.isStaff) {
    return false;
  }

  return true;
}
